module.exports = __webpack_public_path__ + "img/neck_female_mask.845071ec.png";